import * as SentryReact from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { matchPath } from 'react-router-dom';
import { SEVERITY } from '../constants';
const routes = [
    { path: '/settings/organisations/:orgId/flows/new' },
    { path: '/settings/organisations/:orgId' },
    { path: '/settings/assets/:assetId/edit' },
    { path: '/settings/assets/new' },
    { path: '/settings/experience-types/:experienceTypeId/versions/:versionId/css' },
    { path: '/settings/experience-types/:experienceTypeId/edit' },
    { path: '/settings/experience-types/:experienceTypeId/versions/new' },
    { path: '/settings/experience-types/:experienceTypeId/versions' },
    { path: '/settings/step-templates/:stepTemplateId/edit' },
    { path: '/settings/templates/:templateId/steps/new' },
    { path: '/settings/templates/:templateId/steps/:stepId' },
    { path: '/settings/templates/:templateId/edit' },
    { path: '/settings/templates/:templateId/steps' },
    { path: '/settings/layouts/:layoutId/versions/:versionId/edit' },
    { path: '/settings/layouts/:layoutId/versions/new' },
    { path: '/settings/layouts/:layoutId/versions/:versionId' },
    { path: '/settings/layouts/:layoutId/versions' },
    { path: '/settings/layouts/:layoutId/edit' },
    { path: '/settings/themes/:themeId/versions/:versionId/edit' },
    { path: '/settings/themes/:themeId/versions/new' },
    { path: '/settings/themes/:themeId/versions' },
    { path: '/settings/themes/:themeId/edit' },
    { path: '/flows/:flowId/versions/:flowVersionId/steps/:stepId' },
    { path: '/flows/:flowId/versions/:flowVersionId/steps' },
    { path: '/flows/:flowId/versions/:flowVersionId' },
    { path: '/flows/:flowId/events' },
    { path: '/flows/:flowId/exports' },
    { path: '/flows/:flowId' },
    { path: '/flows' },
    { path: '/preview/template/:templateId' },
    { path: '/preview/:flowId/:versionId' },
    { path: '/flow/:flowId' },
];
export function ReactBrowserLoggerEngine(options, sentry) {
    let logger;
    return {
        init: () => {
            let browserTracingOptions = {};
            if (options.history) {
                browserTracingOptions = {
                    routingInstrumentation: SentryReact.reactRouterV5Instrumentation(options.history, routes, matchPath),
                };
            }
            sentry.init({
                ignoreErrors: ['ResizeObserver loop limit exceeded'],
                denyUrls: ['localhost'],
                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for performance monitoring.
                // We recommend adjusting this value in production
                tracesSampleRate: 1.0,
                // This sets the sample rate to be 10%.
                // You may want this to be 100% while in development and sample at a lower rate in production
                replaysSessionSampleRate: 0.1,
                // If the entire session is not sampled, use the below sample rate to sample sessions when an error occurs.
                replaysOnErrorSampleRate: 1.0,
                integrations: [new BrowserTracing(browserTracingOptions), new sentry.Replay()],
                beforeSend: (event, hint) => {
                    if (options.consoleLog) {
                        console.log('SENTRY:', (hint === null || hint === void 0 ? void 0 : hint.originalException) || (hint === null || hint === void 0 ? void 0 : hint.syntheticException));
                        return null;
                    }
                    return event;
                },
                ...options,
            });
            logger = sentry;
        },
        log: ({ level, message, context }) => {
            try {
                logger.withScope((scope) => {
                    scope.setLevel(level || SEVERITY.log);
                    scope.setContext('context', context !== null && context !== void 0 ? context : null);
                    logger.captureMessage(message);
                });
            }
            catch (error) {
                console.trace(error);
                console.trace(message, level);
            }
        },
        logException: (exception, context) => {
            sentry.captureException(exception, context);
        },
        setUser: (user) => {
            sentry.setUser(user);
        },
        clearUser: () => {
            sentry.configureScope((scope) => scope.setUser(null));
        },
        setTag: (key, value) => {
            sentry.setTag(key, value);
        },
        setTags: (tags) => {
            sentry.setTags(tags);
        },
        setContext: (name, ctx) => {
            sentry.setContext(name, ctx);
        },
    };
}
//# sourceMappingURL=react-browser-logger-engine.js.map